import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core'
import { DataPageOfVisit, UiPreferences, Visit } from '../../../../api/models'
import { UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { DatePipe } from '@angular/common'
import { MessageService, SortEvent } from 'primeng/api'
import {
  VisitsService,
  ColumnChooserService,
  AppSettingService,
} from '../../../../api/services'
import { NgxSpinnerService } from 'ngx-spinner'
import { Customsort } from 'src/app/carefinity/directives/customsort'
import { CareFinitySession } from '../../../services/CareFinitySession'

@Component({
  selector: 'app-visits-list',
  templateUrl: './visits-list.component.html',
  styleUrls: ['./visits-list.component.css'],
})
export class VisitsListComponent implements OnInit {
  Item = 'Visits'
  visits: DataPageOfVisit
  selectedPatient: Visit
  Lastpageindex: number = 1
  rows: number
  _selectedColumns: any[]
  showRecords: boolean = false

  private cols: any[]
  othercol: any[]
  pageSize: number = 0;
  pageNumber: number = 1
  sortby: string = 'Desc'
  demographicType: string = 'Visit'
  txtSearch: string = ''
  patientFullName
  showPatientDemographicPrint: boolean = false;
    preferences: UiPreferences = {};
    setPrintFlag: boolean = false;
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private vstservice: VisitsService,
    private columnchooserservice: ColumnChooserService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
    private cstsort: Customsort,
      private appSetting: AppSettingService,
      private messageService: MessageService,
  ) {}

    ngOnInit() {
    this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;
    this.cols = [
      { field: 'shortVisitDate', header: 'Visit Date' },
      { field: 'visitType', header: 'Visit Type' },
      { field: 'appointmentDetails', header: 'Detail' },
      { field: 'renderingProvider', header: 'Seen By' },
      { field: 'location', header: 'Location' },
    ]
    this.patientFullName = sessionStorage.getItem('ptName')
    this.bindVisitList(this.pageNumber, this.sortby)

    this.appSetting
      .appSettingGetPracticeSettings$Response()
      .subscribe((res) => {
          this.showPatientDemographicPrint = res.body.enablePatientDemographicPrint;
          

          if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showPatientDemographicPrint == true) {
              this.setPrintFlag = true;
          }
          else {
              this.setPrintFlag = false;
          }
      })

      const storedPreferences = localStorage.getItem('uiPreferences');
      if (storedPreferences) {
          this.preferences = JSON.parse(storedPreferences);

          this.Item = this.preferences?.visits || 'Visits';
      }
  }

  @Input() get selectedColumns(): any[] {
    // console.log(this._selectedColumns);
    return this._selectedColumns
  }

  set selectedColumns(val: any[]) {
    let selectedValues = [...val]

    if (selectedValues.length == 0) {
      selectedValues = this._selectedColumns = [this.cols[0]]
    } else {
      //restore original order

      this._selectedColumns = val
    }

    let filteredData = Array.prototype.map
      .call(selectedValues, (s) => s.field)
      .toString()
    let filteredValue = Array.prototype.map
      .call(selectedValues, (s) => s.header)
      .toString()

    this.columnchooserservice
      .columnChooserColumnchooser({
        columnNames: filteredData,
        columnValue: filteredValue,
        type: 'Visit',
      })
      .subscribe((result) => {})
  }
  customSort(event: SortEvent, num: number) {
    this.visits.data = this.cstsort.generalcustomSort(event, this.visits.data)
  }
  /**
   * This method is fetch the patient visits or also  search the patient visit on  serach  text.
   *
   *  Parameters Inner::[pageNumber,sortbydirection]
   *  Parameters Outer::[searchText]
   *  ReturnType::[appDateString]
   */
  bindVisitList(pageNumber: number, sortbydirection: string) {
    this.vstservice
      .visitsList({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        pageNumber: pageNumber,
        sortbydirection: sortbydirection,
        searchText: this.txtSearch,
      })
        .subscribe((respVisits) =>
        {
        // console.log(respVisits);
          this.visits = respVisits
          this.visits.data = respVisits.data.map((i) => ({
              ...i,
              ...i.otherColumns,
          }))
        this.rows = this.visits.pageSize

        if (this.visits.totalRecords > 0) {
          this.showRecords = true
        } else {
          this.showRecords = false
            }
                 
            let addedFields = new Set(this.cols.map((col) => col.field))
            for (var key in this.visits.data[0].otherColumns) {
                if (this.visits.data[0].otherColumns.hasOwnProperty(key)) {
                    // Check if key is already in addedFields set
                    if (!addedFields.has(key)) {
                        // Add to addedFields set
                        addedFields.add(key)

                        // Push to this.cols
                        this.cols.push({ field: key, header: key })
                    }
                }
            }
            if (
                this.visits.data[0].savedColumns != null &&
                this.visits.data[0].savedColumns.length > 0
            ) {
                var Savednames = this.visits.data[0].savedColumns.split(',')
                this._selectedColumns = this.cols.filter((col) =>
                    Savednames.includes(col.field),
                )
            } else {
                this._selectedColumns = this.cols
            }
        },
            (err) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: err?.error,
                    life: 3000,
                })
            },
        )
  }

  searchVisits() {
    if (this.txtSearch.length > 1) {
      this.visits = null
      this.rows = null
      this.bindVisitList(this.pageNumber, this.sortby)
    }
  }

  clearSearch() {
    if (this.txtSearch.length >= 0) {
      this.txtSearch = ''
      this.bindVisitList(this.pageNumber, this.sortby)
    }
  }

  printVisits() {
    var PrintVisits = document.getElementById('PrintVisits_List') as HTMLElement
    const printWindow = window.open('', '_blank')
    if (printWindow) {
      const divContent = PrintVisits.innerHTML
      printWindow.document.open()
      printWindow.document.write(
        '<html><head><title>Print::Visits List</title>',
      )
      // Adding CSS styling for alternate rows
      printWindow.document.write('<style type="text/css">')
      printWindow.document.write(
        '    #Visits_print_table_tbody tbody tr:nth-child(odd) {',
      )
      printWindow.document.write('        background-color: #f2f2f2;')
      printWindow.document.write('    }')
      printWindow.document.write(
        '    #Visits_print_table_tbody tbody tr:nth-child(even) {',
      )
      printWindow.document.write('        background-color: #e6e6e6;')
      printWindow.document.write('    }')
      printWindow.document.write('</style>')
      printWindow.document.write('</head><body>')
      printWindow.document.write(divContent)
      printWindow.document.write('</body><html>')
      printWindow.document.close()
      printWindow.focus()
      printWindow.print()
      printWindow.close()
    } else {
      console.error('Failed to open print window.')
    }
  }
}
